(() => {
  if (window.BurgunderPackages) return;
  const root = () => window.Shopify?.routes?.root || '/';
  let busy = false;
  const api = async (path, body) => {
    const response = await fetch(root() + path, {method: body ? 'POST' : 'GET', credentials: 'same-origin', cache:'no-store', headers: {'Content-Type':'application/json','Accept':'application/json'}, ...(body ? {body:JSON.stringify(body)} : {})});
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : 'De winkelwagen kon niet worden bijgewerkt.');
    return data;
  };
  const lines = (cart, id) => cart.items.filter(i => i.properties?._bp_group === id);
  const totals = (items) => {
    const values = new Map();
    for (const item of items) values.set(String(item.variant_id || item.id), (values.get(String(item.variant_id || item.id)) || 0) + item.quantity);
    return values;
  };
  const matches = (cart, id, recipe, count) => {
    const actual = totals(lines(cart, id));
    return actual.size === (count ? recipe.length : 0) && recipe.every(r => (actual.get(String(r.id)) || 0) === r.each * count);
  };
  const setLower = async (cart, id, targets) => {
    const remaining = new Map(targets);
    const updates = {};
    for (const item of lines(cart,id)) {
      const vid = String(item.variant_id || item.id);
      const qty = Math.min(item.quantity, remaining.get(vid) || 0);
      updates[item.key] = qty;
      remaining.set(vid, (remaining.get(vid) || 0) - qty);
    }
    if (Object.keys(updates).length) await api('cart/update.js',{updates});
    return api('cart.js');
  };
  const exclusive = async (fn) => {
    if (busy) throw new Error('Wacht even tot de winkelwagen is bijgewerkt.');
    busy=true; document.documentElement.classList.add('bp-cart-busy');
    try {return await fn();} finally {busy=false; document.documentElement.classList.remove('bp-cart-busy');}
  };
  const add = (items, id, recipe, count) => exclusive(async () => {
    try {
      await api('cart/add.js',{items});
      const cart = await api('cart.js');
      if (!matches(cart,id,recipe,count)) throw new Error('Het pakket is niet volledig toegevoegd.');
      return cart;
    } catch(error) {
      try {
        const cart=await setLower(await api('cart.js'),id,new Map());
        if (lines(cart,id).length) throw new Error('cleanup');
      } catch(_) {error.uncertain=true;}
      throw error;
    }
  });
  const resize = (id, target) => exclusive(async () => {
    const before=await api('cart.js');
    const members=lines(before,id);
    const parent=members.find(i=>i.properties._bp_role==='package');
    if (!parent) throw new Error('Dit pakket is gewijzigd. Vernieuw de winkelwagen.');
    const recipe=JSON.parse(parent.properties._bp_recipe);
    const count=members.filter(i=>i.properties._bp_role==='package').reduce((sum,i)=>sum+i.quantity,0);
    if (!matches(before,id,recipe,count)) throw new Error('Dit pakket is onvolledig. Verwijder het en stel het opnieuw samen.');
    if (target===count) return before;
    try {
      let cart;
      if (target>count) {
        const items=recipe.map(r=>{const line=members.find(i=>String(i.variant_id)===String(r.id));return {id:r.id,quantity:r.each*(target-count),properties:line.properties};});
        await api('cart/add.js',{items}); cart=await api('cart.js');
      } else cart=await setLower(before,id,new Map(recipe.map(r=>[String(r.id),r.each*target])));
      if (!matches(cart,id,recipe,target)) throw new Error('Het aantal pakketten kon niet volledig worden aangepast.');
      return cart;
    } catch(error) {
      if(target>count) {
        try {
          const cart=await setLower(await api('cart.js'),id,totals(members));
          if(!matches(cart,id,recipe,count)) throw new Error('rollback');
        } catch(_) {error.uncertain=true;}
      } else error.uncertain=true;
      throw error;
    }
  });
  const remove = (id) => exclusive(async()=>{
    const cart=await setLower(await api('cart.js'),id,new Map());
    if(lines(cart,id).length) throw new Error('Het pakket kon niet volledig worden verwijderd. Vernieuw de winkelwagen.');
    return cart;
  });
  document.addEventListener('submit',event=>{if((busy || document.documentElement.classList.contains('bp-cart-invalid')) && (event.target.id==='cart' || event.target.action?.includes('/cart'))) {event.preventDefault();event.stopImmediatePropagation();}},true);
  class PackageGroup extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      try {
        const recipe=JSON.parse(this.dataset.recipe),actual=totals(JSON.parse(this.querySelector('[data-bp-group-lines]').textContent));
        if(actual.size!==recipe.length || recipe.some(r=>actual.get(String(r.id))!==r.each*Number(this.dataset.count)))throw new Error('incomplete');
      }catch(_){
        this.dataset.incomplete='true';document.documentElement.classList.add('bp-cart-invalid');
        this.querySelector('[data-bp-group-message]').textContent='Dit pakket is onvolledig. Verwijder het en stel het opnieuw samen voordat je afrekent.';
        this.querySelector('[data-bp-group-action="update"]').disabled=true;
      }
      this.addEventListener('change',e=>e.stopPropagation());
      this.addEventListener('click',async e=>{
        const button=e.target.closest('[data-bp-group-action]');if(!button)return;
        e.preventDefault(); e.stopPropagation();
        const action=button.dataset.bpGroupAction;
        const input=this.querySelector('[data-bp-group-count]');
        const target=Number(input.value);
        if(action==='update' && (!Number.isInteger(target)||target<1||target>99)){input.reportValidity();return;}
        const message=this.querySelector('[data-bp-group-message]');
        this.querySelectorAll('button,input').forEach(x=>x.disabled=true);
        message.textContent=this.dataset.busy;
        try {
          if(action==='remove')await remove(this.dataset.group);else await resize(this.dataset.group,target);
          window.location.reload();
        } catch(error){
          message.textContent=error.uncertain ? this.dataset.uncertain : error.message;
          if(error.uncertain)document.documentElement.classList.add('bp-cart-invalid');
          if(!error.uncertain)this.querySelectorAll('button,input').forEach(x=>x.disabled=false);
        }
      });
    }
  }
  customElements.define('burgunder-package-group',PackageGroup);
  window.BurgunderPackages={api,add,resize,remove,matches};
})();
